import { Button, Text, toast } from '@approvalmax/ui/src/components';
import { FC, memo, useCallback } from 'react';
import { useCompanyBetaFeatures, useCompanyIdBasedOnUrl } from 'shared/hooks';

import { useOffboardingContext } from '../../OffboardingContext';
import { validateExternalRequesterInWorkflow } from '../../OffboardUserPopupContent.helpers';
import { messages } from './PopupButtonsStep1.messages';
import { PopupButtonsStep1Props } from './PopupButtonsStep1.types';

const PopupButtonsStep1: FC<PopupButtonsStep1Props> = memo((props) => {
    const { isLoading, offboardUserData, showSecondStep } = props;

    const { setShowErrors, selectedReplacements: selectedDelegates, showErrors } = useOffboardingContext();

    const { companyId } = useCompanyIdBasedOnUrl();
    const { isPayerOffboarding } = useCompanyBetaFeatures(companyId);

    const onSubmit = useCallback(() => {
        const formValid = offboardUserData
            ? validateExternalRequesterInWorkflow(offboardUserData, selectedDelegates, isPayerOffboarding)
            : false;

        if (!formValid) {
            setShowErrors(true);
            toast.error(messages.error);
        } else {
            setShowErrors(false);
            showSecondStep();
        }
    }, [offboardUserData, selectedDelegates, setShowErrors, showSecondStep, isPayerOffboarding]);

    return (
        <Button
            color='blue80'
            size='medium'
            disabled={
                isLoading ||
                (offboardUserData?.workflows &&
                    !validateExternalRequesterInWorkflow(offboardUserData!, selectedDelegates, isPayerOffboarding) &&
                    showErrors)
            }
            onClick={onSubmit}
        >
            <Text font='body' wrap={false}>
                {messages.removeFromWorkflows}
            </Text>
        </Button>
    );
});

export default PopupButtonsStep1;
